import { MANDATORY_FIELD } from 'config/zodConfig';
import zod from 'zod';

export const LoginFormSchema = zod.object({
  email: zod
    .string({ required_error: MANDATORY_FIELD })
    .email('Email inválido.'),
  password: zod
    .string({ message: MANDATORY_FIELD })
    .min(1, { message: MANDATORY_FIELD }),
});

export const RegisterFormSchema = zod.object({
  email: zod
    .string({ required_error: 'Campo obrigatório' })
    .min(1, { message: MANDATORY_FIELD })
    .email('Email inválido.'),
  password: zod
    .string({ message: 'Campo obrigatório' })
    .min(1, { message: MANDATORY_FIELD })
    .min(8, { message: 'A senha deve ter no minimo 8 caracteres.' })
    .max(10, { message: 'A senha deve ter no maximo 10 caracteres.' }),
  name: zod
    .string({ required_error: MANDATORY_FIELD })
    .min(1, { message: MANDATORY_FIELD }),
  cpf: zod.string().optional(),
  cnpj: zod.string().optional(),
  postalCode: zod
    .string({
      message: 'Campo obrigatório',
    })
    .min(1, { message: MANDATORY_FIELD })
    .min(8, { message: 'O CEP deve conter 8 caracteres.' })
    .max(8, { message: 'O CEP deve conter 8 caracteres.' }),

  city: zod.string({}).min(1, { message: MANDATORY_FIELD }),
  state: zod
    .string({
      message: 'Campo obrigatório',
    })
    .min(1, { message: MANDATORY_FIELD }),
  street: zod
    .string({
      message: 'Campo obrigatório',
    })
    .min(1, { message: MANDATORY_FIELD }),
  addrNumber: zod
    .string({
      message: 'Campo obrigatório',
    })
    .min(1, { message: MANDATORY_FIELD }),
  neighborhood: zod
    .string({
      message: 'Campo obrigatório',
    })
    .min(1, { message: MANDATORY_FIELD }),
  product: zod.string({
    message: 'Campo obrigatório',
  }),

  plans: zod
    .string({
      message: 'Campo obrigatório',
    })
    .array(),
});
